import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content"];
// @ts-check
import React from "react";
import DefaultTrivia from "../DefaultTrivia";
import { defineTrivia } from "../defineTrivia";
import { CONTAINER_TRIVIA_BEGIN } from "../positions";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default defineTrivia({
  getPosition: function getPosition() {
    return CONTAINER_TRIVIA_BEGIN;
  },
  Component: function Component(_ref) {
    var content = _ref.content,
      props = _objectWithoutProperties(_ref, _excluded);
    var _ref2 = content || {},
      expert = _ref2.expert;
    if (!expert) {
      return null;
    }
    return /*#__PURE__*/_jsx(DefaultTrivia, _objectSpread(_objectSpread({}, props), {}, {
      className: "trivia-author",
      thumbnail: "/img/experts/crop_".concat(expert.picture),
      thumbnailTitle: expert.name,
      thumbnailStyle: {},
      header: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("strong", {
          children: [expert.name, ", "]
        }), " ", /*#__PURE__*/_jsx("span", {
          children: expert.profession
        })]
      })
    }));
  }
});
//# sourceMappingURL=Author.js.map